/* eslint-disable no-eval */
/* eslint-disable no-undef-init */
/* eslint-disable no-unused-vars */
const Scene = require('./Scene').Scene
const Screenplay = require('./Screenplay').Screenplay
const Message = require('./Message').Message
const Game = require('./Game').Game
const { AudioResource } = require('./Resource')
const tools = require('./script-tools')
// const safeEval = require('safe-eval')
const _ = require('lodash')
const axios = require('@/lib/axios').default

export async function getScreenplays(page = 1, countPerPage = 20, opts = {}){
  let params = {
    p: page,
    count: countPerPage
  }
  if(opts.self){
    params.self = true
  }
  let res = await axios.get(`/wordprison/screenplays`, {
    params
  })
  return res.data
}

export async function getScreenplayCount(opts = {}){
  let params = {}
  if(opts.self){
    params.self = true
  }
  let res = await axios.get(`/wordprison/screenplays/count`, {
    params
  })
  return parseInt(res.data)
}
export async function loadScreenplay(screenplayId){
  let res = await axios.get(`/wordprison/screenplay/${screenplayId}`)
  return new Screenplay(res.data)
}
export async function loadScene(screenplayId, sceneId){
  let res = await axios.get(`/wordprison/screenplay/${screenplayId}/${sceneId}`)
  return new Scene(res.data)
}
/**
 * 若指定 screenplayId 將回傳多筆的結果
 * recordId 則為單筆
 * @param {*} opts
 */
export async function loadGameRecord(opts = {}){
  let res
  if(opts.screenplayId){
    let select = ['id', 'sid', 'uid', 'created_at', 'updated_at', 'data']
    if(opts.withoutData){
      select = ['id', 'sid', 'uid', 'created_at', 'updated_at']
    }
    // 查詢多筆
    // 查詢多筆時，如果包含參數withoutData則不取得data
    // 此時會有複數的result
    res = await axios.get(`/wordprison/records/${opts.screenplayId}`, {
      params: {
        select
      }
    })
  // eslint-disable-next-line no-constant-condition
  }else if(opts.recordId){
    res = await axios.get(`/wordprison/record/${opts.recordId}`)
  }else{
    throw new Error('missing parameter')
  }
  return res.data
}

export function updateScreenplay(screenplay){
  let tmpScenes = screenplay.scenes
  screenplay.scenes = undefined
  let patch = JSON.parse(JSON.stringify(screenplay))
  screenplay.scenes = tmpScenes
  return axios.patch(`/wordprison/screenplay/${screenplay.id}`, patch)
}

export function saveScreenplay(screenplay, opts = {}){
  let params = {}
  if(opts.create){
    params.create = true
  }
  let data = { ...screenplay }
  if(data.author && typeof data.author === 'object'){
    data.author = data.author.id
  }
  return axios.post(`/wordprison/screenplay/${data.id}`, data, { params })
}
export function saveScene(screenplayId, scene){
  return axios.post(`/wordprison/screenplay/${screenplayId}/${scene.id}`, scene)
}
export function saveGameRecord(screenplayId, gameRecord){
  return axios.post(`/wordprison/record/${screenplayId}`, gameRecord)
}

export function deleteScene(screenplayId, sceneId){
  return axios.delete(`/wordprison/screenplay/${screenplayId}/${sceneId}`)
}

/**
 * @param {Screenplay} screenplay
 */
export function preloadResource(screenplay){
  // audios固定要載入的資源
  let audios = [
    new AudioResource({
      id: 'type-effect',
      src: '/audios/typewriter.mp3'
    })
  ]
  audios = audios.concat(screenplay.resources.audios)
  return Promise.all(audios.map((resource)=>{
    return loadAudio(resource)
  })).then((list)=>{
    for(let item of list){
      if(item.error){
        console.warn(`load audio failed ${item.src}`)
      }
    }
  })
}
/**
 * @param {AudioResource} resource
 */
export function loadAudio(resource){
  let { src, id } = resource
  console.log('loadAudio', src, id)
  return new Promise((resolve, reject)=>{
    let audio = new Audio(src)
    if(id){
      audio.id = id
    }
    audio.addEventListener('canplaythrough', (event)=>{
      resource.loaded = true
      resolve({
        audio,
        src,
        event,
        eventName: 'canplaythrough'
      })
    })
    audio.addEventListener('error', (e)=>{
      resolve({
        src,
        error: e
      })
    })
    document.getElementById('resources').appendChild(audio)
  })
}
export async function load(gameId){
  var screenplay = null
  var script = (await axios.get(`/game/${gameId}`)).data
  var window = null
  var load
  var require
  let context = {
    screenplay,
    axios,
    Scene,
    Screenplay,
    Message,
    Game,
    _,
    lodash: _,
    tools
  }
  let tmp = eval(script)
  return screenplay || tmp
}
export async function run(script, wrapper = false){
  var screenplay = null
  var window = null
  var load
  var require
  let context = {
    screenplay,
    axios,
    Scene,
    Screenplay,
    Message,
    Game,
    _,
    lodash: _,
    tools
  }
  eval(script)
}
